import { useEffect } from "react";

export function useUndoRedoShortcut(
	containerRef: React.RefObject<HTMLElement | null> | null,
	{ onUndo, onRedo }: { onUndo: () => void; onRedo: () => void },
): void {
	useEffect(() => {
		const handleKeyDown = (e: KeyboardEvent) => {
			if (containerRef && !containerRef.current?.contains(e.target as Node)) {
				return;
			}
			const isCtrl = e.ctrlKey || e.metaKey;
			if (!isCtrl) {
				return;
			}
			if (e.key === "z" && !e.shiftKey) {
				e.preventDefault();
				onUndo();
			} else if (e.key === "y") {
				e.preventDefault();
				onRedo();
			} else if (e.key === "z" && e.shiftKey) {
				e.preventDefault();
				onRedo();
			}
		};

		document.addEventListener("keydown", handleKeyDown);
		return () => {
			document.removeEventListener("keydown", handleKeyDown);
		};
	}, [containerRef, onUndo, onRedo]);
}
